import React from 'react';
import Tag from './Tag';
import cn from 'classnames';

type Props = {
  className?: string;
}

export default function HashTag({className, children}: React.PropsWithChildren<Props>) {
  return (
    <Tag className={cn(className, 'uppercase font-medium text-xs p-1')}>
      #{children}
    </Tag>
  );
}
